import type { AutoTradingStockListItem, AutoTradingStockSetting } from "@/types/autotrading"
import client from "./client"

export async function getAutoTradingStocks(): Promise<AutoTradingStockListItem[]> {
  const { data } = await client.get<AutoTradingStockListItem[]>("/api/autotrading/stocks")
  return data
}

export async function addAutoTradingStock(stockCode: string, strategyType?: string): Promise<void> {
  await client.post(`/api/autotrading/stocks/${stockCode}`, strategyType ? { strategyType } : undefined)
}

export async function removeAutoTradingStock(stockCode: string): Promise<void> {
  await client.delete(`/api/autotrading/stocks/${stockCode}`)
}

export async function getAutoTradingStockSettings(stockCode: string): Promise<AutoTradingStockSetting> {
  const { data } = await client.get<AutoTradingStockSetting>(`/api/autotrading/stocks/${stockCode}/settings`)
  return data
}

export async function updateAutoTradingStockSettings(
  stockCode: string,
  payload: AutoTradingStockSetting
): Promise<AutoTradingStockSetting> {
  const { data } = await client.put<AutoTradingStockSetting>(`/api/autotrading/stocks/${stockCode}/settings`, payload)
  return data
}
